// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
  padding: 24px;
}

@media only screen and (min-width: 1200px) {
  .modal-container {
    min-height: 100%;
    margin-top: 0;
    padding: 0 35px 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal/filter-gallery-modal/filter-gallery-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAGA;EACE;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;EAAF;AACF","sourcesContent":[".modal-container {\n  padding: 24px;\n}\n\n\n@media only screen and (min-width: 1200px) {\n  .modal-container {\n    min-height: 100%;\n    margin-top: 0;\n    padding: 0 35px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
